"use client";

import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import KonfigurasiLogoCard from "@/app/Components/KonfigurasiLogoCard";
import { KonfigurasiLogos } from "../constant";

const KonfigurasiLogo = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start 0", "end 1"],
  });

  return (
    <div ref={sectionRef} className="relative h-[300vh]">
      {/* <div className="absolute flex flex-col w-full h-full">
        <div id={0} className="h-screen w-full bg-red-500" />
        <div id={1} className="h-screen w-full bg-green-500" />
        <div id={2} className="h-screen w-full bg-blue-500" />
      </div> */}
      <div
        className="sticky top-0 flex flex-col justify-center items-start gap-5 md:gap-10 h-screen w-full overflow-hidden pt-28 bg-cover bg-center px-5 md:px-10 lg:px-20"
        style={{
          backgroundImage: "url('/image/bg-hero-filosofi1.webp')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t bg-black/70" />
        <motion.div
          className="z-40 text-white font-semibold text-2xl sm:text-4xl lg:text-5xl text-center lg:text-left"
          initial={{
            opacity: 0,
            x: 100,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 1,
          }}
          viewport={{ once: true }}
        >
          Penataan Visual Logo
        </motion.div>
        <div className="w-full h-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {KonfigurasiLogos.map((konfigurasi, index) => (
              <KonfigurasiLogoCard
                key={index}
                image={konfigurasi.image}
                index={index}
                scrollYProgress={scrollYProgress}
                // sectionRef={sectionRef}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KonfigurasiLogo;
